if ($('#app-ratings-radio-audience-comp').length) {
    var form_markets;

    var form_curr_market;
    var form_curr_books;
    var market_type;
    var form_curr_book_limit;
    var form_curr_area = 'Metro';

    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

        var table=   $('#ratings_radio_audience_comp_table ').DataTable();
        console.log('table',table);
        var ages=[];
        table.rows().eq(0).each( function ( index ) {
            var row = table.row( index );

            var data = row.data();
            console.log('row.data', data)
            ages.push(data['demo']);
        } );
        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Age Range...',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var data_type = 'impressions';
            var demo_type = $('#chart_demo_options').val();
            var columns = [];
            for (var b in demo_type) {
                var string = '';
                string += demo_type[b]+'_'+data_type;
                columns.push(string);
            }

            var results=[];
            var results_per=[];
            var thousands_total = 0;
            for(var i in demo_type) {
                results[demo_type[i]] = [];
                results_per[demo_type[i]] = [];
                for(var y in age_charts) {
                    results[demo_type[i]][age_charts[y]] = [];
                    results_per[demo_type[i]][age_charts[y]] = [];
                }
            }
            var demo_names={
                m: 'Men',
                f: 'Women',
                p: 'Person',
            };
            console.log('results', results);

            var table=   $('#ratings_radio_audience_comp_table ').DataTable();

            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                console.log('row.data', data)
                if(age_charts.indexOf(data['demo']) !== -1 ){
                    for(var i in columns){
                        var string= columns[i].split('_');
                        results[string[0]][data['demo']][columns[i]]= (!isNaN(data[columns[i]])) ? data[columns[i]] : 0;
                        thousands_total += (!isNaN(data[columns[i]])) ? parseFloat(data[columns[i]]) : 0;
                        results_per[string[0]][data['demo']][string[0]+'_per']= (!isNaN(data[string[0]+'_per'])) ? data[string[0]+'_per'] : 0;
                    }
                }
            });

            console.log('results', results);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series = [];
                for (var demo in results) {
                    var data = [];
                    for (var age in results[demo]) {
                        for (var col in results[demo][age]) {
                            var string = col.split('_');
                            var perc = string[0] + '_per';
                            if ($('#chart_data_type option:selected').val() == 'both') {
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                    percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            } else if ($('#chart_data_type option:selected').val() == 'impressions') {
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                    // percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            } else {
                                data.push({
                                    name: age,
                                    y: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                        }
                    }
                    series.push({
                        name: demo_names[demo],
                        data: data,
                    });
                }

                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#market').html()+' ; '+ $('#books').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5 px"><b'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];
                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    for(var age in results[demo]){
                        var total_age= 0;
                        for(var col in results[demo][age]){
                            var string= col.split('_');
                            var perc= string[0]+'_per';
                            total += parseFloat(results[demo][age][col]);
                            total_age += parseFloat(results[demo][age][col]);
                        }
                        arr.push({name: age, y: total_age, x: parseFloat(results_per[demo][age][perc]), drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo_names[demo],
                        id: demo,
                        data: arr,
                    });

                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((total * 100) / thousands_total)).toFixed(2) : 0;
                    series.push({
                        name: demo_names[demo],
                        y: total,
                        x: percent,
                        drilldown: demo,
                    });
                }
                console.log('data2', data2);
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Hundreds (00) & Percent (%)';

                var dt_type_name= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Hundreds";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Hundreds & Percent';

                Highcharts.setOptions(Highcharts.theme);
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#market').html()+' ; '+ $('#books').html(),
                    },
                    subtitle:{
                        // text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' ) '+ \n + ' Click the slices to view ' + $('#chart_data_type option:selected').html() +' by Age Range. ',
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>',
                        // text: 'Source: <br><span style="color:red">WorldClimate.com</span>',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">'+ dt_type_name +': </td>' +
                            '<td style="padding:5px"><b>'+ format +' </b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: $('#report_type_hidden').val(),
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('06:00', '15:00', 'radio');

        $.ajax({
            type: "GET",
            url: (location.href.indexOf('ratings/eastlan-radio/composition/audience') < 0) ? '/ratings/radio/markets' : '/ratings/eastlan-radio/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name')/*.keyBy('code')*/.all();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['code'] + '">' + value['name'] + '</option>')
                });

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).bind('change', function () {
                    ratingsRadioCompAudienceOnMarketChange(this);
                });

                $('#form_geography').select2({
                    minimumResultsForSearch: 10
                }).bind('change', function () {
                    form_curr_area = $(this).val();
                    $(this).attr('disabled', 'disabled');
                });

                $('#form_station').select2({
                    placeholder: "Select a book...",
                    minimumResultsForSearch: 10
                });

                $('#form_books').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    ratingsRadioCompAudienceReset();
                });

                $('#form_submit').bind('click', function(){
                    ratingsRadioCompAudienceSubmit();
                });

                form_markets = data;

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    });

    var ratingsRadioCompAudienceSubmit = function()
    {
        show_loader();

        books = $('#form_books').val();
        station = $('#form_station').val();
        area = $('#form_geography').val();

        dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        dp_end = moment($('#form_day_part_end').val(), 'h:mm A');

        day_part = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        $.ajax({
            url: '/ratings/radio/books/composition/audience?' + $.param({
                books: books,
                station: station,
                day_part: day_part,
                area: area,
                cume: $("#cumeopt").val(),
            }),
            success: function (data) {
                console.log("audience");
                console.log(data);
                table_data = [];

                books_html = '';
                market_html = '';

                market_type = '';

                $.each(data['books'], function(index, value){
                    if(index === 0){
                        market_html = value['market']['name'] + ' ' + value['market']['type'] + ' ';
                        if(value['market']['type'] === 'PPM'){
                            market_type = 'PPM';
                            $('#nielsen-disclaimer').find('.ppm-disclaimer').removeClass('hidden');
                        }else{
                            market_type = 'Diary';
                            $('#nielsen-disclaimer').find('.ppm-disclaimer').addClass('hidden');
                        }
                    }

                    books_html += value['period_name'];

                    if(index !== (data['books'].length - 1)){
                        books_html += '/';
                    }
                });

                $('#market').html(market_html);
                $('#books').html(books_html);
                $('#station').html(data['station']['name'] + ' (' + data['station']['frequency']+ ')');
                $('#day_part').html(ratingsHumanDaypart(day_part));
                $('#area').html(area);


                if(market_type === 'PPM'){
                    p_base = data['impressions']['6+']['P']['impressions']*2;
                    m_base = data['impressions']['6+']['M']['impressions']*2;
                    f_base = data['impressions']['6+']['F']['impressions']*2;
                }else{
                    p_base = data['impressions']['12+']['P']['impressions']*2;
                    m_base = data['impressions']['12+']['M']['impressions']*2;
                    f_base = data['impressions']['12+']['F']['impressions']*2;
                }


                $.each(data['impressions'], function(index, value){
                    if($.inArray(index, ['6+', '12+']) === -1){
                        push = {
                            'demo' : index
                        };

                        if(typeof data['impressions'][index]['M'] === 'undefined'){
                            push['m_impressions'] = '';
                            push['m_per'] = ''
                            push['m_intab'] = true;
                        }else{
                            data['impressions'][index]['M']['impressions'] *= 2;
                            push['m_impressions'] = (data['impressions'][index]['M']['impressions'] > 50) ? Math.round(data['impressions'][index]['M']['impressions'] / 100).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            }) : 0;
                            push['m_per'] = (data['impressions'][index]['M']['impressions'] > 50) ? Number(Math.round(((Math.round(data['impressions'][index]['M']['impressions']/100) / Math.floor(p_base/100)) * 100) +'e1')+'e-1') : 0;
                            push['m_intab'] = data['impressions'][index]['M']['intab'];
                        }

                        if(typeof data['impressions'][index]['F'] === 'undefined'){
                            push['f_impressions'] = '';
                            push['f_per'] = ''
                            push['f_intab'] = true;
                        }else{
                            data['impressions'][index]['F']['impressions'] *= 2;
                            push['f_impressions'] = (data['impressions'][index]['F']['impressions'] > 50) ? Math.round(data['impressions'][index]['F']['impressions'] / 100).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            }) : 0;
                            push['f_per'] = (data['impressions'][index]['F']['impressions'] > 50) ? Number(Math.round(((Math.round(data['impressions'][index]['F']['impressions']/100) / Math.floor(p_base/100)) * 100) +'e1')+'e-1') : 0;
                            push['f_intab'] = data['impressions'][index]['F']['intab'];
                        }
                        data['impressions'][index]['P']['impressions'] *= 2;
                        push['p_impressions'] = (data['impressions'][index]['P']['impressions'] > 50) ? Math.round(data['impressions'][index]['P']['impressions'] / 100).toLocaleString("en-US", {
                            minimumFractionDigits: 0
                        }) : 0;
                        push['p_per'] = (data['impressions'][index]['P']['impressions'] > 50) ? Number(Math.round(((Math.round(data['impressions'][index]['P']['impressions'] / 100) / Math.floor(p_base/100)) * 100) +'e1')+'e-1') : 0;
                        push['p_intab'] = data['impressions'][index]['P']['intab'];

                        table_data.push(push);
                    }

                });


                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_radio_audience_comp_table').find('tbody').empty();
                }

                dt = $('#ratings_radio_audience_comp_table').DataTable( {
                    columns: [
                        {
                            data: "demo"
                        },{
                            data: "m_impressions"
                        },{
                            data: "m_per"
                        },{
                            data: "f_impressions"
                        },{
                            data: "f_per"
                        },{
                            data: "p_impressions"
                        },{
                            data: "p_per"
                        }
                    ],
                    "columnDefs": [
                        {
                            "orderable": false,
                            "targets": '_all'
                        },
                        {
                            render: function ( data, type, row, meta ) {
                                var curr_intab = true;
                                var html = '';
                                if(meta['col'] === 2){
                                    if(! row['m_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }else if(meta['col'] === 4){
                                    if(! row['f_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }else if(meta['col'] === 6){
                                    if(! row['p_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }

                                if(! curr_intab){
                                    var disclaimer = $('#nielsen-disclaimer');
                                    if(disclaimer.find('.intab-disclaimer-individual').hasClass('hidden')){
                                        disclaimer.find('.intab-disclaimer-individual').removeClass('hidden');
                                    }
                                }

                                html += data;
                                return html;
                            },
                            targets: [2, 4, 6]
                        }
                    ],
                    "order": [],
                   /* dom: 'Bfrtip',
                    buttons: [
                        'copy',
                        {
                            extend: 'excel',
                            messageTop:   market_html+' > '+ books_html+' > '+area+' > '+$('#station').html()+' > '+ ratingsHumanDaypart(day_part),
                        },
                        {
                            extend: 'csv',
                            messageTop:   market_html+' > '+ books_html+' > '+area+' > '+$('#station').html()+' > '+ ratingsHumanDaypart(day_part),
                        },
                        {
                            extend: 'print',
                            messageTop:   market_html+' > '+ books_html+' > '+area+' > '+$('#station').html()+' > '+ ratingsHumanDaypart(day_part),
                        },
                    ],*/
                    "searching": false,
                    "paging": false,
                    "info": false,
                    data: table_data
                } );
                var td=  $('#ratings_radio_audience_comp_table td');
                for(var i in td)
                {
                    if(td[i].innerHTML== '2-5')
                        td[i].innerHTML= '(2 - 5)';
                    if(td[i].innerHTML== '6-11')
                        td[i].innerHTML= '(6 - 11)';
                    if(td[i].innerHTML== '12-17')
                        td[i].innerHTML= '(12 - 17)';
                    if(td[i].innerHTML== '18-24')
                        td[i].innerHTML= '(18 - 24)';
                    if(td[i].innerHTML== '25-34')
                        td[i].innerHTML= '(25 - 34)';
                    if(td[i].innerHTML== '35-44')
                        td[i].innerHTML= '(35 - 44)';
                    if(td[i].innerHTML== '45-49')
                        td[i].innerHTML= '(45 - 49 )';
                    if(td[i].innerHTML== '50-54')
                        td[i].innerHTML= '(50 - 54)';
                    if(td[i].innerHTML== '55-64')
                        td[i].innerHTML= '(55 - 64)';
                    if(td[i].innerHTML== '65+')
                        td[i].innerHTML= '(65+)';

                }

                hide_loader();

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

                ratingsRadioCompAudienceReset();
                $('#radio_comp_audience_generate_panel').find('div.clickable').click();

            }
        });
    };
    $('#export_excel_aud_radio').on('click', function(){
        var x= market_html+' > '+ books_html+' > '+area+' > '+$('#station').html()+' > '+ ratingsHumanDaypart(day_part);

        var html_header= '<table> ' +
            '<tr> ' +
            '<td style="background-color: #f5f5f5" colspan="7"><span style="size: 12px">  <b> Radio Ratings Audience Composition<b></span></td>' +
            '</tr> ' +
            '<tr> <td style="background-color: #f5f5f5" colspan="7"> </td></tr>' +
            '<tr>' +
            '<td style="background-color: #f5f5f5; font-size: size: 12px" colspan="7"> ' + x+ '</td></tr>' +
            '<tr></tr>' +
            '</table>';

        $("#ratings_radio_audience_comp_table th:contains(Men)")
            .css("background-color", "#f2643d");
        $("#ratings_radio_audience_comp_table th:contains(Women)")
            .css("background-color", "#f2643d");
        $("#ratings_radio_audience_comp_table th:contains(Persons)")
            .css("background-color", "#f2643d");

        $("#ratings_radio_audience_comp_table th:contains(Demo)")
            .parents("tr")
            .css("background-color", "#f8ab91");

        $("#ratings_radio_audience_comp_table tbody tr:odd")
            .css("background-color", "#f0ffff");



        html_header += $('.audience-ratings-table').html();


        exportToExcel(html_header);


    });

    function exportToExcel(html){
        var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        location.href=url;
        return false;
    }

    var ratingsRadioCompAudienceReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + value['code'] + '">' + value['name'] + '</option>')
            });

            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).bind('change', function () {
                ratingsRadioCompAudienceOnMarketChange(this);
            });
        }

        if((step < 2) || (step === 'all')){
            input = $('#form_books');

            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form-books-container').addClass('hidden');
            input.closest('.form-books-container').parent().find('.help-text').removeClass('hidden');

            input = $('#form_geography');
            input.val('Metro').trigger("change");
            input.attr('disabled', 'disabled');
            input.closest('.form-group').find('.help-text').addClass('hidden');

            form_curr_area = 'Metro';
        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_station');

            input.data('select2').destroy();
            input.unbind('change');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a book...",
                minimumResultsForSearch: 10
            });
            $('#form_submit').attr('disabled', 'disabled');
        }
    };

    var ratingsRadioCompAudienceOnMarketChange = function(select){
        show_loader();
        form_curr_market = collect(form_markets).where('code', parseInt($(select).val())).first();

        var input = $('#form_geography');

        input.val('Metro').trigger("change");
        if(form_curr_market['type'] === 'PPM'){
            input.attr('disabled', 'disabled');
            input.closest('.form-group').find('.help-text').removeClass('hidden');
        }else{
            input.attr('disabled', null);
            input.closest('.form-group').find('.help-text').addClass('hidden');
        }

        $.ajax({
            type: "GET",
            url: '/ratings/radio/books/?code=' + $(select).val(),
            dataType: 'json',
            success: function (data) {
                var input = $('#form_books');

                input.attr('disabled', null);
                input.multiSelect('destroy');

                input.html('');
                // $.each(data, function (index, value) {
                //     input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                // });
                var dates_ordered= data;
                var OrdDates= Object.entries(dates_ordered).sort((a,b) => (a[1].end > b[1].end) ? 1 : ((b[1].end > a[1].end) ? -1 : 0));

                var cont = OrdDates.length - 1;
                while(cont >= 0){
                    var value= OrdDates[cont][1];
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                    cont--;
                }

                var html = '';
                if(form_curr_market['frequency'] === 13){
                    form_curr_book_limit = 13;
                    html = 'Books will be averaged. Maximum of Thirteen.<span class="pull-right"><small><span class="select-count text-muted">(0 / 13)</span></small></span>';
                }else if(form_curr_market['frequency'] === 4){
                    form_curr_book_limit = 4;
                    html = 'Books will be averaged. Maximum of Four.<span class="pull-right"><small><span class="select-count text-muted">(0 / 4)</span></small></span>';
                }else{
                    form_curr_book_limit = 1;
                    html = 'Maximum of One.<span class="pull-right"><small><span class="select-count text-muted">(0 / 1)</span></small></span>';
                }

                $('.form-books-container').find('.text-default').html(html);

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_books = this.$element.val();
                        if(this.$element.val().length <= form_curr_book_limit){
                            ratingsCompAudienceOnBooksChange();
                        }else{
                            form_curr_books = this.$element.val();
                            this.$element.multiSelect('deselect', values);
                        }

                        if(form_curr_books.length < form_curr_book_limit){
                            this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / ' + form_curr_book_limit + ')').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / '  + form_curr_book_limit + ')').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_books = this.$element.val();
                        if(form_curr_books.length > 0){
                            ratingsCompAudienceOnBooksChange();
                        }else{
                            ratingsRadioCompAudienceReset(2);
                        }

                        this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                input.closest('.form-books-container').removeClass('hidden');
                input.closest('.form-books-container').parent().find('.help-text').addClass('hidden');

                ratingsRadioCompAudienceReset(2);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsCompAudienceOnBooksChange = function(select){
        var parameters = '?';
        $.each(form_curr_books, function (index, value) {
            parameters += 'books[]=' + value + '&';
        });
        var url = '/ratings/radio/books/stations/' + parameters + '&area=' + form_curr_area;

        show_loader();
        $.ajax({
            type: "GET",
            url: url,
            dataType: 'json',
            success: function (data) {
                var input = $('#form_station');

                input.attr('disabled', null);
                input.data('select2').destroy();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });

                input.bind('change', function () {
                    $('#form_submit').attr('disabled', null);
                });

                ratingsRadioCompAudienceReset(3);
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };
};
